module.exports = __webpack_public_path__ + "static/media/icon-interview-system-design.465bf840.svg";